const CHECKED_IN_STATUSES = new Set(['present', 'late']);

export const normalizeAttendanceStatus = (value) => String(value || '').trim().toLowerCase();

export const getCheckedInTimestamp = (session) => {
  if (!session) return null;

  return (
    session.checked_in_at_utc ||
    session.checkedInAtUtc ||
    session.checked_in_at ||
    session.last_checkin ||
    null
  );
};

export const hasCheckedInRecord = (session) => {
  if (!session) return false;

  if (typeof session.is_checked_in === 'boolean') {
    return session.is_checked_in;
  }

  if (typeof session.isCheckedIn === 'boolean') {
    return session.isCheckedIn;
  }

  const currentStatus = normalizeAttendanceStatus(session.current_status);
  const status = normalizeAttendanceStatus(session.status);
  const attendanceStatus = normalizeAttendanceStatus(session.attendance_status);

  if (
    CHECKED_IN_STATUSES.has(currentStatus) ||
    CHECKED_IN_STATUSES.has(status) ||
    CHECKED_IN_STATUSES.has(attendanceStatus)
  ) {
    return true;
  }

  return Boolean(getCheckedInTimestamp(session));
};
